module.exports = __webpack_public_path__ + "img/ic-home-huiyuan.f3b0.463bf056.png";